import { JobPosition } from "../../domain";

export interface JobPositionSearchCriteria {
    searchText: string;
    jobCategoryIds?: number[];
}

export const JobCategoryEnum = {
    MANAGEMENT: { name: "Management", id: 1011 },
    BUSINESS_FINANCIAL: { name: "Business & Financial", id: 1013 },
    COMPUTER_MATHEMATICAL: { name: "Computer & Mathematical", id: 1015 },
    ARCHITECTURE_ENGINEERING: { name: "Architecture & Engineering", id: 1017 },
    LIFE_PHYSICAL_SOCIAL_SCIENCE: {
        name: "Life, Physical & Social Science",
        id: 1019,
    },
    COMMUNITY_SOCIAL_SERVICE: { name: "Community & Social Service", id: 1021 },
    LEGAL: { name: "Legal", id: 1023 },
    DESIGN_MEDIA_COMMUNICATIONS: {
        name: "Design, Media & Communications",
        id: 1027,
    },
    HEALTHCARE_PRACTITIONERS_TECHNICAL: {
        name: "Healthcare Practitioners & Technical",
        id: 1029,
    },
    HEALTHCARE_SUPPORT: { name: "Healthcare Support", id: 1031 },
    PERSONAL_CARE_SERVICE: { name: "Personal Care & Service", id: 1039 },
    SALES: { name: "Sales", id: 1041 },
    OFFICE_ADMINISTRATIVE_SUPPORT: {
        name: "Office & Administrative Support",
        id: 1043,
    },
    INSTALLATION_MAINTENANCE_REPAIR: {
        name: "Installation, Maintenance & Repair",
        id: 1049,
    },
    TRANSPORTATION: { name: "Transportation", id: 1053 },
};

export interface IJobPositionLookupService {
    loadSuggestions: (
        criteria: JobPositionSearchCriteria
    ) => Promise<JobPosition[]>;
}
